import { call, put, takeLatest } from "redux-saga/effects";

import fifaService from "../../../services/fifaService";
import {
  FETCH_FIFA_MATCHES_REQUEST,
  fetchFifaMatchesSuccess,
  fetchFifaMatchesFailure,
} from "../../redux/fifa";

function* handleFetchFifaMatches(action) {
  try {
    const { limit, page } = action.payload;

    const response = yield call(
      fifaService.getFifaMatches,
      limit,
      page
    );

    console.log("FIFA API RESPONSE:", response);

    // FIXED
    if (response?.error) {
      yield put(
        fetchFifaMatchesFailure(
          response.error.message || "Failed to fetch FIFA matches"
        )
      );

      return;
    }

    // FIXED
    const matches = response?.data?.fifaMatches || [];

    yield put(fetchFifaMatchesSuccess(matches));

  } catch (error) {
    console.error("FIFA SAGA ERROR:", error);

    yield put(
      fetchFifaMatchesFailure(error.message)
    );
  }
}

export default function* fifaSaga() {
  yield takeLatest(
    FETCH_FIFA_MATCHES_REQUEST,
    handleFetchFifaMatches
  );
}